@if (label()) {
  <div class="label truncate" i18n>Correo electrónico</div>
}
<div class="value">
  <a class="qaroni-link-on-surface" href="mailto:{{ email() }}">{{
    email()
  }}</a>
</div>
